export default function addQueryParams(url: string, key: string, value: string) {
  try {
    const urlData = new URL(url)
    urlData.searchParams.set(key, value)
    return urlData.toString()
  } catch (error) {
    return url
  }
}
